module.exports = __webpack_public_path__ + "img/icon2.292e318b.png";